module.exports = __webpack_public_path__ + "img/accessibilidade_surdos.3933f287.webp";